module.exports = __webpack_public_path__ + "static/media/lumen.7edc24c1.png";